export function clampVoiceEnergy(value) {
  return Math.max(0, Math.min(1, Number(value) || 0));
}

// Shared microphone envelope used by both production Live Voice and Voice Lab.
// A fast attack preserves consonants; the slower release prevents visual jitter.
export function measureVoiceEnergy(samples, previousLevel = 0) {
  if (!samples?.length) return { level: 0, peak: 0, rms: 0 };

  let peak = 0;
  let squares = 0;
  for (let index = 0; index < samples.length; index += 1) {
    const normalized = (samples[index] - 128) / 128;
    peak = Math.max(peak, Math.abs(normalized));
    squares += normalized * normalized;
  }

  const rms = Math.sqrt(squares / samples.length);
  const belowFloor = rms < 0.006 && peak < 0.018;
  const weighted = belowFloor ? 0 : clampVoiceEnergy((rms * 0.78 + peak * 0.48) * 3.15);
  const shaped = Math.pow(weighted, 0.74);
  const previous = clampVoiceEnergy(previousLevel);
  const coefficient = shaped > previous ? 0.64 : 0.14;
  const level = previous + (shaped - previous) * coefficient;

  return {
    level: level < 0.006 ? 0 : clampVoiceEnergy(level),
    peak,
    rms,
  };
}
